import { LOGIN_URL, LOGOUT_URL } from '@/constants/global'
import { MainFooter, MainHeader } from '@mercedes-benz/oneweb-next-react-components'
import { atom } from 'jotai'
import { ComponentProps } from 'react'
import { VehicleBodyStyle } from "@/types/global";
import { SearchResultURL, SuggestionAPI } from '@/constants';

type GlobalData = {
  footer: ComponentProps<typeof MainFooter> | null
  header: ComponentProps<typeof MainHeader>['burgerMenuData'] | null
  vehicleList: ComponentProps<typeof MainHeader>['vehicleListData'] | null
  userInfo: Omit<ComponentProps<typeof MainHeader>['userInfo'], 'notLogin'>
  search: {
    placeholder: string
    result: string[]
    suggestionAPI: string
    searchResultURL: string
  }
  bodyStyles: VehicleBodyStyle[] | null
  mainHeaderPopup?: boolean
}

export const globalData = atom<GlobalData>({
  footer: null,
  header: null,
  vehicleList: null,
  search: {
    placeholder: '',
    result: [],
    suggestionAPI: SuggestionAPI,
    searchResultURL: SearchResultURL
  },
  userInfo: {
    status: 'notLogin',
    username: '',
    userPhone: '',
    loginUrl: LOGIN_URL,
    logoutUrl: LOGOUT_URL,
  },
  bodyStyles: null,
})
